<template>
  <div class="_box">
    
    <!-- 🔙 Top row (Back + Title) -->
    <div class="_box--header">
        <!-- Back button -->
          <div style="margin-bottom: 60px;" class="back-btn">
            <router-link to="/dashboard" class="back-link">
              ← Back to Dashboard
            </router-link>
          </div>

      <!-- Title center -->
      <div style="margin-top: 60px;" class="title">
        <h1>{{ name }}</h1>
      </div>
    </div>

    <!-- Divider -->
    <div v-if="!hideDivider" class="_box--divider">
      <app-svg-icon 
        name="brand/NG_DIVIDER"
        class="_box--divider--icon"
        :color="color"
      />
    </div>

    <!-- Slot content -->
    <slot></slot>

    <!-- Background Icon -->
    <div v-if="icon" class="_box--bg_element hidden-sm-and-down">
      <slot name="icon">
        <app-svg-icon 
          name="brand/NG_HAS_CAR" 
          color="var(--orange)" 
        />
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-name-page',
  props: {
    name: String,
    icon: Boolean,
    hideDivider: Boolean,
    color: {
      type: String,
      default: 'var(--green)'
    }
  }
}
</script>

<style lang="stylus" scoped>
._box
  display flex
  flex-direction column
  justify-content flex-start
  align-items center
  position relative
  padding 16px
  width 100%
  box-sizing border-box

/* Top row */
._box--header
  display flex
  align-items center
  justify-content center
  position relative
  width 100%
  max-width 800px
  margin 0 auto
  padding 0 16px

/* Back button → left */
.back-btn
  position absolute
  left 16px
  display flex
  align-items center

/* Title center */
.title
  flex 1
  text-align center
  h1
    font-size 42px
    margin 0
    word-break break-word

/* Divider */
._box--divider
  margin-top 12px
  text-align center
  ._box--divider--icon
    width 110px

/* Background icon */
._box--bg_element
  position absolute
  right 10%
  bottom 33%
  width 110px
  height 100px
  .svg-icon
    width 100%
    height 100%
    transform rotate(23deg)

/* Back link */
.back-link
  font-size 13px
  font-weight 500
  color #000
  text-decoration underline
  cursor pointer
  transition color 0.3s ease

.back-link:hover
  color var(--blue)

/* Responsive styles */
@media (max-width: 599px)
  ._box
    padding-top 24px
  ._box--header
    justify-content flex-start
    padding-left 8px
  .title h1
    font-size 20px
    text-align left
  .back-btn
    position relative
    top 0
    left 0
    transform none
    margin-right 8px
  ._box--divider ._box--divider--icon
    width 80px
</style>



// WEBPACK FOOTER //
// src/components/app-name-page.vue